import { useState, useEffect, useCallback } from "react";
import { useClient } from "../context/ClientProvider";
import { useAuthenticatedApiFetch } from "../hooks/useAuthenticatedApiFetch";
import ApiConstants from "../utils/ApiConstants";
import { useMsal } from "@azure/msal-react";
import { useAppNavigation } from "../hooks/useAppNavigation";
import useProduct from "../hooks/useProduct";

const useLanguageFetcher = () => {
    const { instance } = useMsal();
    const authenticatedApiFetch = useAuthenticatedApiFetch(instance);
    const { goToError } = useAppNavigation();

    const [language, setLanguage] = useState("English");
    const [error, setError] = useState(null);
    const client = useClient();
    const product = useProduct();

    const fetchLanguageForClient = useCallback(async () => {
        if (!client) return;

        try {
            await instance.initialize();

            const endpoint = ApiConstants.getClientLanguageEndpoint(client, product);
            const url = `${ApiConstants.BASE_URL}${endpoint}`;

            const result = await authenticatedApiFetch(url, {}, "txt");

            if (result.status !== 200) {
                console.error(`API returned status ${result.status}. Redirecting to error page.`);
                goToError();
                return;
            }

            const data = result.data;
            try {
                const jsonData = JSON.parse(data);
                setLanguage(jsonData);
            } catch (e) {
                setLanguage(data);
            }
        } catch (error) {
            console.error("Error fetching language:", error);
            setError(error);
            goToError(); 
        } 
    }, [client, instance, product, authenticatedApiFetch]);

    useEffect(() => {
        fetchLanguageForClient();
    }, []);

    return { language, error, fetchLanguageForClient };
};

export default useLanguageFetcher;
